import {PartyRole} from '@sollapay/enums';
import {InfoTooltip} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {PartyTypeToggle} from '@/components/roster';

import type {ButtonGroupItemDef, IconName} from '@sollapay/ui/components';
import type {FC} from 'react';

const ROLE_ICONS: Partial<Record<PartyRole, IconName>> = {
  [PartyRole.SELLER]: 'marker-pin-06',
  [PartyRole.OPTION_HOLDER]: 'route'
};

export interface SellerRoleToggleProps {
  value: PartyRole | '';
  options: PartyRole[];
  onChange: (value: PartyRole) => void;
  error?: string;
}

/** Which side of an option deal a roster row sits on: the land owner, or the option holder. */
export const SellerRoleToggle: FC<SellerRoleToggleProps> = ({value, options, onChange, error}) => {
  const {t} = useTranslation('trustAccounts');
  const prefix = 'activation.packages.trustDetails.form';

  if (options.length < 2) return null;

  const items: ButtonGroupItemDef[] = options.map(role => ({
    value: role,
    label: t(`${prefix}.options.sellerRoles.${role}`),
    icon: ROLE_ICONS[role]
  }));

  return (
    <PartyTypeToggle
      className="w-fit"
      label={t(`${prefix}.fields.sellerRole`)}
      labelSuffix={<InfoTooltip content={t(`${prefix}.fields.sellerRoleTooltip`)} />}
      required
      error={error}
      value={value}
      onChange={val => onChange(val as PartyRole)}
      items={items}
    />
  );
};
